// eg. urlWithQuery('https://example.com', { foo: 'bar', baz: 'qux' }) => 'https://example.com?foo=bar&baz=qux'
// eg. urlWithQuery('https://example.com', { foo: 'bar', baz: null }) => 'https://example.com?foo=bar'
export const urlWithQuery = (path, queryParams = {}) => {
  const queryString = Object.entries(queryParams)
    .map(([key, value]) => value !== undefined ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : null)
    .filter(Boolean)
    .join('&')
  return queryString ? `${path}?${queryString}` : path
}

// eg. setUrlParam('https://example.com?foo=bar', 'foo', 'baz') => 'https://example.com?foo=baz'
// eg. setUrlParam('https://example.com?foo=bar', 'foo', null) => 'https://example.com'
export const setUrlParam = (url, paramName, paramValue) => {
  const urlObj = new URL(url, window.location.origin)
  if (paramValue) {
    urlObj.searchParams.set(paramName, paramValue)
  } else {
    urlObj.searchParams.delete(paramName)
  }
  return urlObj.toString()
}
